define(['jquery', 'backbone', 'backbone.marionette', 'hudl-react-kickoff/legacy/lib/backbone.wreqr'],
    function ($, backbone, Marionette, Wreqr) {

        return Wreqr.radio.channel('global').vent;
    });
